export enum FirebaseCollectionEnum {
  HALFWAY_RESULTS = "halfway-results",
  OCCASIONS = "occasions",
  LOCATIONS = "locations",
}
